module.exports = __webpack_public_path__ + "img/tuohi@2x.0c56768.png";